import { injectable } from "inversify";

import * as Api from "../constants/ApiUrlConstants";
import IoCContainer from '../wires/Bootstrapper';
import { IApiService } from "./shared/ApiService";
import SERVICE_IDENTIFIER from "../wires/Identifiers";
import { SearcherBaseModel } from "../models/SearcherBaseModel";
import { ProjectionPagedModel } from "../models/ProjectionPageModel";
import { LicenzeProjection, BuyOutputModel } from "../models/Licenza";
import { PagedBaseState } from "../models/PagedBaseState";

export interface ILicenzeService  {
    CompraLicenza(clienteId: string): Promise<BuyOutputModel>
    Search(search: SearcherBaseModel): Promise<ProjectionPagedModel<LicenzeProjection>>
    Render(): Promise<PagedBaseState<LicenzeProjection>>
}

@injectable()
export class LicenzeService implements ILicenzeService {

    RenderApi = Api.RenderLicenze
    apiService: IApiService

    constructor() {
        this.apiService = IoCContainer.get(SERVICE_IDENTIFIER.API_SERVICE);
    }

    async Render(): Promise<PagedBaseState<LicenzeProjection>> {
        return await this.apiService.getAsync<PagedBaseState<LicenzeProjection>>(Api.RenderLicenze, {});
    }

    async CompraLicenza(clienteId:string): Promise<BuyOutputModel> {
        return await this.apiService.getAsync<BuyOutputModel>(Api.CompraLicenzaTenant, { clienteId });
    }

    async Search(search: SearcherBaseModel): Promise<ProjectionPagedModel<LicenzeProjection>> {
        return await this.apiService.getAsync<ProjectionPagedModel<LicenzeProjection>>(Api.SearchLicenze, search);
    }
}